import React, { useState, useEffect } from 'react';
import Translations from '../../services/translation.service';
import PaymentFailureIcon from "../../assets/img/PaymentOnboardingFailed.svg";
import User from "../../services/user.service";
import Storage from '../../services/storage.service';
import Settings from '../../services/settings.service';
import SpinnerTimeLoader from '../shared/timeLoading';
import DownloadApps from '../shared/DownloadApps';
import FirebaseAnalytics from "../../services/analytics.service";
import Helpers from '../../helpers/shared.helper';
import CONSTANTS from '../../services/constants.service';

const subscriptions = [];
const PaymentFailure = ({ capturing = false, group = "none", apple = false }) => {
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})
    const [error, setError] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [loader, setLoader] = useState(false);
    const [errorGroup, setErrorGroup] = useState(group);
    const [appleCapturing, setAppleCapturing] = useState(false);

    useEffect(() => {
        const paymentCaptureEnabled = Helpers.getStorageBooleanValue(CONSTANTS.ENABLE_PAYMENT_CAPTURE);
        if(apple) {
            setAppleCapturing(paymentCaptureEnabled);
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect(() => {
        setLoader(true);
        Storage.get_obsrv("paymentErrorCode").subscribe(data => {
            setError(data);
            let err = data ? data.toString().replace('-', '_') : "";
            setErrorMsg("error" + err);
        });

        // Check if error data is stored in persistent storage (for page reload scenarios)
        const storedErrorData = Storage.get("paymentErrorData", true);
        if (storedErrorData) {
            try {
                const errorData = JSON.parse(storedErrorData);
                if (errorData.group && errorData.group !== "none") {
                    setErrorGroup(errorData.group);
                }
                if (errorData.errorCode) {
                    setError(errorData.errorCode);
                    let err = errorData.errorCode ? errorData.errorCode.toString().replace('-', '_') : "";
                    setErrorMsg("error" + err);
                }
            } catch (e) {
                console.error("Error parsing stored error data:", e);
            }
        }

        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )
        setLoader(false);
        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }

    }, []);

    const paymentHandling = (actionType = "try_again") => {
        setLoader(true);
        Storage.clear("paymentFailedError");
        Storage.clear("paymentErrorStatus");
        Storage.clear("calledFeatureConfirmation");
        Storage.clear("confirmSuccess");
        Storage.clear("confirmFailed");
        Storage.clear("paymentSuccess");
        Storage.clear("paymentErrorData"); // Clear the stored error data (group + error code)
        // If action is "add_new_card", set flag for direct card entry
        if (actionType === "add_new_card" && !apple) {
            Storage.set("direct_card_entry", true, true);
        }
        User.fetchFlowStatus().then(() => {
            setLoader(false);
            window.location.href = "/join/#/pay/";
        }).catch(() => {
            setLoader(false);
            Storage.clear("paymentFailedError");
            Storage.clear("paymentErrorStatus");
            window.location.reload();
        });
        const firebase_event_params = {
            event_category: 'onboarding_payment',
            event_screen: 'payment_failed',
            interaction_type: 'click',
            event_label: actionType,
            error_code: error || ""
        }
        FirebaseAnalytics.commonFunction(firebase_event_params);
    }

    const callMemberCare = () => {
        const firebase_event_params = {
            event_category: 'onboarding_payment',
            event_screen: 'payment_failed',
            interaction_type: 'click',
            event_label: "call_member_care",
            error_code: error || ""
        }
        FirebaseAnalytics.commonFunction(firebase_event_params);
    }

    return (<div className="payment-summary-success-failure">
        {loader ? <SpinnerTimeLoader /> :
            <div className="payment-summary-failure payment-summary-capture">
                <img src={PaymentFailureIcon} alt={translationKeys["payment_not_completed"]}></img>
                {capturing || appleCapturing ? <>
                    <div className='payment-success-title'>
                        {translationKeys[`payment_capture_title_error_${`${error}`.replace("-", "")}`] || translationKeys["payment_capture_failed"]}
                    </div>
                    <div className='payment-success-desc'>
                        {translationKeys[`payment_capture_description_error_${`${error}`.replace("-", "")}`] || translationKeys[`payment_capture_failed_desc_${errorGroup}`] || translationKeys["payment_capture_failed_desc"]} 
                    </div>
                    <div className="common-multi-buttons">
                        {errorGroup !== "group10" && <button onClick={() => paymentHandling("try_again")}> {translationKeys["ob_try_again"]}</button>}
                        {errorGroup !== "group8" && <a href={`tel:${Helpers.getPOValue("member_care_call_number", "")}`} onClick={callMemberCare} className="common-button-light"> {translationKeys["ob_call_member_care"] || "Call member care"}</a>}
                        {/* {errorGroup !== "group10" && <button onClick={() => paymentHandling("add_new_card")}> {translationKeys["ob_add_new_card"] || "Add new card"}</button>} */}
                    </div>
                </> :
                    <>
                        <div className='payment-success-title'>
                            {translationKeys["payment_not_completed"]}
                        </div>
                        <div className='payment-success-desc'>
                            {translationKeys[errorMsg] || translationKeys["payment_failure_desc"]}
                            <br/>
                            {error ? <>{translationKeys["stm_general_failed_err_code"]}{" "}{error}</> : ""}
                            <br/>
                            <br/>
                            {translationKeys[errorMsg + "_desc"] || translationKeys["payment_failure_sub_desc"]}
                        </div>
                        <button className="common-button" onClick={() => paymentHandling("try_again")}> {translationKeys["ob_try_again"]}</button>
                    </>
                }
                <DownloadApps
                    info={translationKeys["scr_3.3.3_app_download_info"]}
                    classes={"download-apps"}
                    google_play_link={Settings.google_play_link}
                    app_store_link={Settings.app_store_link}
                    huawei_store_link={Settings.huawei_store_link}
                />
            </div>
        }
    </div>
    )
}

export default PaymentFailure;